import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { catchError, shareReplay } from 'rxjs/operators';

// Single place that knows how the app learns its own public ip - used by
// ClientIpInterceptor to stamp every outgoing request, so callers never
// have to fetch or thread an ip through their own requests again.
@Injectable()
export class ClientIpService {
  private clientIp$: Observable<string>;

  public getClientIp(): Observable<string> {
    if (!this.clientIp$) {
      // shareReplay(1): only the first caller actually hits ipify - every
      // request after that (and every request before the first one
      // resolves) replays the same cached result/error instead of firing
      // a new lookup.
      this.clientIp$ = fromPromise(
        fetch('https://api.ipify.org?format=json')
          .then((res) => res.json())
          .then((data) => data.ip)
      ).pipe(
        catchError(() => of(null)),
        shareReplay(1)
      );
    }
    return this.clientIp$;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/client-ip.service.ts